import {
  useQuery,
  keepPreviousData,
  useQueryClient,
  useMutation,
} from "@tanstack/react-query";
import { fetchGetQuery, fetchDeleteQuery } from "../api";
import urlBuilder from "../../components/utils/dataGridURLBuilder";
import determineSorting from "../../components/utils/determineSorting";

// Custom hook to fetch paginated tenders with sorting, searching and filtering
export function useGetTendersPagination(
  pagination,
  sorting,
  search,
  columnFilters,
) {
  const { pageIndex, pageSize } = pagination;

  // Determine sorting field and direction
  const { sortField, sortDirection } = determineSorting(sorting);

  // Filter out inactive filters (empty values)
  const activeFilters = columnFilters.filter((f) =>
    Array.isArray(f.value) ? f.value.length : f.value,
  );

  // Build URL with pagination, sorting, search and active filters
  const url = urlBuilder(
    "Razpisi/seznamRazpisovPaginationV2",
    pagination,
    sortField,
    sortDirection,
    search,
    activeFilters,
  );

  return useQuery({
    queryKey: [
      "tenders",
      pageIndex,
      pageSize,
      sortField,
      sortDirection,
      search,
      columnFilters,
    ],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });
}

//DELETE API call to delete razpisi by id
export function useDeleteTender() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (idRazpis) => {
      return fetchDeleteQuery(`Razpisi/${idRazpis}`);
    },
    onSuccess: () => {
      // Invalidate and refetch project list queries after successful delete
      queryClient.invalidateQueries({
        queryKey: ["tenders"],
      });
    },
  });
}
